import 'react-select/dist/react-select.css'

import { render, unmountComponentAtNode } from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import PluginProvider from '../components/providers/plugin-provider'
import BookingPluginMiddleware from '../middlewares/plugin/booking-plugin'
import LeaguesPluginMiddleware from '../middlewares/plugin/leagues-plugin'

import rootReducer from '../reducers/plugin'

const middlewares = [BookingPluginMiddleware, LeaguesPluginMiddleware]

const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose

window.App.store = createStore(
  rootReducer,
  {},
  composeEnhancers(applyMiddleware(...middlewares))
)

window.App.run = ({
  container,
  type,
  containerId = 'appContainer',
  payload
}) => {
  if (!container) container = document.getElementById(containerId)
  if (!container) return
  window.App.store.dispatch({ type: type + '.INIT', payload })
  if (container.childElementCount > 0) return
  render(PluginProvider({ store: window.App.store, type: type }), container)
}

window.App.stop = ({ container, containerId = 'appContainer' }) => {
  if (!container) container = document.getElementById(containerId)
  if (!container) return
  unmountComponentAtNode(container)
}
